import { render, staticRenderFns } from "./IndicationsHistory.vue?vue&type=template&id=abe6567c"
import script from "./IndicationsHistory.vue?vue&type=script&lang=js"
export * from "./IndicationsHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports